import TTItalic from "@tiptap/extension-italic"
import type { Mark as ProsemirrorMark, Schema } from "prosemirror-model"

import { ItalicExtension } from "./ItalicModel"

const componentName = "em"

const component = TTItalic.extend({
  name: componentName,
})

const converter = {
  fromPrismic(schema: Schema) {
    return function (): ProsemirrorMark | undefined {
      return schema.marks[component.name]?.create()
    }
  },

  toPrismic() {
    return undefined
  },
}

const EditorItalic = new ItalicExtension(componentName, component, converter)

// eslint-disable-next-line import/no-default-export
export default EditorItalic
